import 'design/index.css'
import { app_version, client } from 'config/environment'
import { isCustomMetaRoute, meta } from 'feature/meta'
import { Notices } from 'feature/notice/Notices'
import { useEffectOnce } from 'hook/useEffectOnce'
import { initI18next } from 'i18n/init'
import Head from 'next/head'
import 'page/css/index.scss'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import { opt } from 'store/opt'
import css from './app.module.scss'
import './app.css'

function App({ Component, pageProps }: any) {
  useState(() => {
    if (client) {
      console.info('window', app_version)
    }
  })

  const [show, setShow] = useState(false)

  useEffectOnce(() => {
    document.body.classList.toggle(css.square, opt.square)

    return () => {
      document.body.classList.remove(css.square)
    }
  })

  useEffectOnce(() => ui.window.client())
  useEffectOnce(() => setShow(true))

  const { route } = useRouter()
  const custom = isCustomMetaRoute(route)

  return (
    <>
      {!custom && (
        <Head>
          <title>{meta.title}</title>
          <link rel="icon" href={meta.icon} />
          <meta name="description" content={meta.description} />
        </Head>
      )}
      <Head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,user-scalable=no"
        />
      </Head>
      <div className={show ? css.app : css.none}>
        <Component {...pageProps} />
      </div>
      {show && <Notices />}
    </>
  )
}

// do not remove this!
initI18next.then(() => undefined)

export default App
